import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Legal.css';

const Legal = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-page">
      <div className="legal-container">

        <div className="legal-header">
          <h1>Información Legal</h1>
          <p>Información importante sobre nuestros términos, políticas y avisos legales</p>
        </div>

        <div className="legal-content">
          {/* Aviso de Privacidad */}
          <section className="legal-section">
            <h2>Aviso de Privacidad</h2>
            <div className="legal-text">
              <p>
                <strong>Distracker</strong> con domicilio en <strong>México</strong>, es responsable del tratamiento de sus datos personales.
                La información que recabamos (nombre, teléfono, correo electrónico, dirección de envío, datos de facturación) será utilizada
                para fines de contacto, facturación, envío de productos, soporte técnico y promociones relacionadas con nuestros rastreadores GPS Meitrack.
              </p>
              <p>
                Usted puede ejercer sus derechos ARCO enviando un correo a <strong>privacidad@distracker.com</strong>.
                Para conocer nuestro Aviso de Privacidad completo, visite <strong>distracker.com/privacidad</strong>.
              </p>
            </div>
          </section>

          {/* Términos y Condiciones */}
          <section className="legal-section">
            <h2>Términos y Condiciones</h2>
            <div className="legal-text">
              <p>El uso de este sitio web implica la aceptación de los siguientes términos y condiciones:</p>
              <ul>
                <li>Los precios están en pesos mexicanos e incluyen IVA, salvo que se indique lo contrario.</li>
                <li>Los envíos se realizan únicamente dentro de México mediante <strong>Estafeta</strong>.</li>
                <li>Todos los rastreadores GPS Meitrack cuentan con garantía de <strong>12</strong> meses por defectos de fabricación.</li>
                <li>La instalación y configuración son responsabilidad del cliente salvo que se contrate el servicio adicional.</li>
                <li>El uso de los dispositivos para actividades ilícitas es estrictamente prohibido y será responsabilidad exclusiva del comprador.</li>
                <li>Nos reservamos el derecho de modificar precios y condiciones sin previo aviso.</li>
              </ul>
            </div>
          </section>

          {/* Política de Envíos y Devoluciones */}
          <section className="legal-section">
            <h2>Política de Envíos y Devoluciones</h2>
            <div className="legal-text">
              <ul>
                <li>El tiempo estimado de entrega es de <strong>3-5</strong> días hábiles después de la confirmación de pago.</li>
                <li>En caso de recibir un producto defectuoso, el cliente deberá reportarlo dentro de los primeros 5 días naturales posteriores a la entrega para proceder con el cambio o devolución.</li>
                <li>No se aceptan devoluciones por mal uso o instalación incorrecta del dispositivo.</li>
              </ul>
            </div>
          </section>

          {/* Uso de Cookies */}
          <section className="legal-section">
            <h2>Uso de Cookies</h2>
            <div className="legal-text">
              <p>
                Este sitio utiliza cookies para mejorar la experiencia del usuario y analizar el tráfico.
                Al continuar navegando, acepta nuestro uso de cookies.
              </p>
            </div>
          </section>


        </div>

        <div className="legal-footer">
          <p>Última actualización: Enero 2025</p>
          <p>Distracker - Todos los derechos reservados</p>
        </div>
      </div>
    </div>
  );
};

export default Legal; 